/* Karban site overhaul — data + render + nav interactions (vanilla JS) */

/* Gokwik KwikPass (kp-merchant-v2.js) leaves style="overflow:auto" on <body>
   after its scroll-lock routine. An inline overflow:auto makes <body> its own
   scroll container, which silently kills EVERY position:sticky on the page
   (nav, PDP gallery, compare bar). 'auto' is visually identical to the default
   here, so strip it whenever any script sets it; real locks ('hidden') pass
   through untouched. Proven root cause via headless probe, 19 Jul 2026. */
(function(){
  function fix(){ if(document.body && document.body.style.overflow==='auto'){ document.body.style.overflow=''; } }
  function arm(){ fix(); new MutationObserver(fix).observe(document.body,{attributes:true,attributeFilter:['style']}); }
  if(document.body){ arm(); } else { document.addEventListener('DOMContentLoaded', arm); }
})();

var CDN = 'https://karban.in/cdn/shop/files/';
var PRODUCTS = [
  {
    id: 'airzone-pure-plus',
    name: 'Airzone Pure Plus',
    cat: 'Air Purifiers',
    badge: 'Bestseller',
    price: '₹36,999',
    white_price: '₹35,999',
    href: '/products/karban-airzone-pure-plus',
    tag: 'HEPA air purifier, air circulator and colour-changing light — for medium to large rooms.',
    black: "//karban.in/cdn/shop/t/536/assets/pureplus-black.webp?v=158129902228938513601787118640",
    white: "//karban.in/cdn/shop/t/536/assets/pureplus-white.png?v=169519062547114578241787118640"
  },
  {
    id: 'airzone-smart-plus',
    name: 'Airzone Smart Plus',
    cat: 'Bladeless Fans',
    badge: 'New launch',
    price: '₹30,999',
    white_price: '₹29,999',
    href: '/products/karban-airzone-smart-plus',
    tag: 'Air circulator and colour-changing light, large format — with Dual Zone Technology.',
    black: "//karban.in/cdn/shop/t/536/assets/smartplus-black.webp?v=132011410409523405821787118650",
    white: "//karban.in/cdn/shop/t/536/assets/smartplus-white.png?v=119072240517418444801787118651"
  },
  {
    id: 'airzone-pure',
    name: 'Airzone Pure',
    cat: 'Air Purifiers',
    badge: null,
    price: '₹19,999',
    white_price: '₹18,999',
    href: '/products/karban-airzone-pure',
    tag: 'HEPA air purifier, air circulator and colour-changing light — for standard rooms.',
    black: "//karban.in/cdn/shop/t/536/assets/pure-black.webp?v=177977170598241993471787118639",
    white: "//karban.in/cdn/shop/t/536/assets/pure-white.png?v=162628197107741716061787118639"
  },
  {
    id: 'airzone-smart',
    name: 'Airzone Smart',
    cat: 'Bladeless Fans',
    badge: null,
    price: '₹15,999',
    white_price: '₹14,999',
    href: '/products/karban-airzone-smart',
    tag: 'Air circulator and colour-changing light — for standard rooms.',
    black: "//karban.in/cdn/shop/t/536/assets/smart-black.webp?v=176613768171475702901787118648",
    white: "//karban.in/cdn/shop/t/536/assets/smart-white.png?v=93314327788177292311787118649"
  },
  {
    id: 'lumone',
    name: 'Lumone',
    cat: 'Lights',
    badge: 'Modular',
    price: '₹2,999',
    href: '/products/lumone',
    tag: 'Modular linear LED light — connect and reconfigure your layout.',
    black: "//karban.in/cdn/shop/t/536/assets/lumone-black.png?v=53412616802212620041787118622",
    white: "https://cdn.shopify.com/s/files/1/0847/4909/1122/files/White-Lumone.png?v=1787979173"
  }
];
/* accessories & services (store page) — live products on karban.in */
var ACCESSORIES = [
  {
    id: 'hepa-filter',
    name: 'HEPA Filter',
    cat: 'Accessories',
    badge: null,
    price: '₹1,999',
    href: '/products/hepa-filter',
    tag: 'Replacement HEPA filter for Airzone Pure and Pure Plus — keep purification at full strength.',
    img: "//karban.in/cdn/shop/t/536/assets/hepa-filter.png?v=103151657110450920961787118597"
  },
  {
    id: 'amc',
    name: 'AMC',
    cat: 'Accessories',
    badge: null,
    price: '₹1,999',
    href: '/products/amc',
    tag: 'Annual maintenance contract — yearly service and care for your Airzone.',
    img: "//karban.in/cdn/shop/t/536/assets/amc.png?v=123988953736909304661787118577"
  },
  {
    id: 'installation',
    name: 'Installation',
    cat: 'Accessories',
    badge: null,
    price: '₹899',
    href: '/products/karbans-installation',
    tag: 'Professional installation within 48–52 hours of delivery, across 15,000+ pin codes.',
    img: "//karban.in/cdn/shop/t/536/assets/installation.png?v=183195325452020262591787118600"
  }
];

/* url = article link placeholder (outlet site) — replace with the exact article URLs when available */
/* Real articles — line = actual headline, summary = what the piece covers, url = article link.
   ⚠️ BusinessLine + Inshorts exact article URLs pending from Shubham (not web-indexed) — currently
   pointing at the publication homepage. */
var PRESS = [
  {
    name: 'Forbes',
    logo: "//karban.in/cdn/shop/t/536/assets/forbes.png?v=39185217269429282101787118595",
    note: 'Bladeless breakthrough',
    line: 'Tanya Goyal — Forbes 30 Under 30 Asia 2025.',
    summary: 'Karban co-founder Tanya Goyal features on the Forbes 30 Under 30 Asia 2025 list (Retail & E-commerce) — recognising the company behind the Airzone, the 3-in-1 ceiling appliance designed and built in India.',
    url: 'https://www.forbes.com/profile/tanya-goyal/'
  },
  {
    name: 'The Hindu BusinessLine',
    logo: "//karban.in/cdn/shop/t/536/assets/businessline.png?v=70974717179289444471787118581",
    note: 'Homegrown innovation',
    line: 'Smart home gadgets with a desi edge.',
    summary: 'The Hindu BusinessLine features Karban among the homegrown brands giving smart home gadgets a desi edge — the Airzone folds an air purifier, an air circulator and a light into one made-in-India ceiling appliance.',
    url: 'https://www.thehindubusinessline.com'
  },
  {
    name: 'Entrackr',
    logo: "//karban.in/cdn/shop/t/536/assets/entrackr.png?v=129761272909399292651787118587",
    note: 'Smart raise',
    line: 'KARBAN raises seed round led by All In Capital, Titan Capital and Rainmatter.',
    summary: 'Entrackr reports Karban’s ₹8.93 crore seed round led by All In Capital, Titan Capital and Rainmatter — with Urban Company, JK Family Office and angels including Kunal Shah and Anupam Mittal participating.',
    url: 'https://entrackr.com/2024/04/karban-raises-seed-round-led-by-all-in-capital-titan-capital-and-rainmatter/'
  },
  {
    name: 'Inc42',
    logo: "//karban.in/cdn/shop/t/536/assets/inc42.png?v=58248691971748979311787118599",
    note: 'Funded future',
    line: 'Can this Jaipur-based startup’s 3-in-1 bladeless fans take over Indian homes?',
    summary: 'Inc42’s feature on the Jaipur-based startup asks whether Karban’s 3-in-1 bladeless fans — airflow, purification and light in a single fixture — can take over Indian homes.',
    url: 'https://inc42.com/startups/can-this-jaipur-based-startups-3-in-1-bladeless-fans-take-over-indian-homes/'
  },
  {
    name: 'Inshorts',
    logo: "//karban.in/cdn/shop/t/536/assets/inshorts.png?v=19104558495657174811787118600",
    note: 'Energy-efficient',
    line: 'Smart appliances startup KARBAN raises ₹8.93 crore in funding.',
    summary: 'Inshorts carried the news of Karban raising ₹8.93 crore in seed funding to scale its smart 3-in-1 ceiling appliances and support new product development.',
    url: 'https://www.inshorts.com'
  },
  {
    name: 'Indian Startup News',
    logo: "//karban.in/cdn/shop/t/536/assets/isn.png?v=170902600731387202251787118601",
    note: 'Smart appliances',
    line: 'Smart appliances startup KARBAN raises $1.07M led by All In Capital, Titan Capital and Rainmatter.',
    summary: 'Indian Startup News covers Karban’s $1.07M (₹8.93 crore) seed round led by All In Capital, Titan Capital and Rainmatter, to fuel growth, strengthen the team and support new product development.',
    url: 'https://indianstartupnews.com/funding/smart-appliances-startup-karban-raises-seed-round-led-by-all-in-capital-titan-capital-and-rainmatter-4508674'
  }
];

/* Fallback only — used if no "Review source product" is set in the KBV4 Home
   section settings yet, or the selected product(s) have no pdp_reviews data.
   The live path is window.HOME_REVIEWS, set by kbv4-home.liquid straight from
   each product's own custom.pdp_reviews metafield — the same one the PDP
   itself reads — so editing a product's reviews updates this section too. */
var FALLBACK_REVIEWS = [
  {
    n: 'Prafull Bamniya',
    s: 'Gujarat',
    img: "//karban.in/cdn/shop/t/536/assets/prafull.jpg?v=19759768908419612241787118638",
    t: "I'm an architect and bought this for an office project — honestly, it's the best in its category. Perfect for hanging in compact spaces, with remote control, dimmable light, and a fan + air-purifier combo. The BLDC fan makes it even better — highly recommended."
  },
  {
    n: 'Kirti Bansal',
    s: 'Himachal Pradesh',
    img: "//karban.in/cdn/shop/t/536/assets/kirti.jpg?v=25758761351149810761787118608",
    t: "Using Karban in my kids' bedroom — very useful for hot, humid days. Great decision honestly. Colour is beautiful, the app is great, and the AQI sensor helps track air quality. Easy-to-use remote — a unique and genuinely useful device."
  },
  {
    n: 'Rhea M.',
    s: 'Karnataka',
    img: "//karban.in/cdn/shop/t/536/assets/rhea.jpg?v=173983501825698019301787118645",
    t: "Air-quality difference is noticeable within a reasonable time. I bought one to replace my old air-circulator — amazing airflow and light."
  },
  {
    n: 'Pragati',
    s: 'Odisha',
    img: "//karban.in/cdn/shop/t/536/assets/pragati.jpg?v=176942447404123674611787118638",
    t: "Great product and company support. Installation was smooth with their video-call help. Works well for maintaining AQI, and filters are affordable — perfect for my son's study table."
  },
  {
    n: 'Neeraj K.',
    s: 'Rajasthan',
    img: "//karban.in/cdn/shop/t/536/assets/neeraj.jpg?v=97894716388920510551787118635",
    t: "Beautiful remote, easy to control. The lighting feature is more useful than I expected. Solid purchase."
  },
  {
    n: 'Amit S.',
    s: 'Sikkim',
    img: "//karban.in/cdn/shop/t/536/assets/amit.jpg?v=12362892212823282701787118577",
    t: "Wasn't sure at first, but the Airzone has genuinely improved airflow in my living room. The bladeless design feels safe with kids around."
  }
];
var VIDEOS = [
  { id:'Q32ucZ7puV4', t:'Karban Origins: the Airzone' },
  { id:'m-tXKUVU75M', t:'Why Karban?' },
  { id:'yn-cGn5UaME', t:'How Karban solved it for you' },
  { id:'kI-_sS_WNBk', t:'Real stories' },
  { id:'BIDVjW-QME8', t:'Airzone in a real home' },
  { id:'bi9j55IJlqo', t:'The 3-in-1 ceiling appliance' },
];

function pcardHTML(p){
  var whitePrice = p.white_price || p.price;
  return '<div class="pcard" data-black="'+p.black+'" data-white="'+p.white+'" data-black-price="'+p.price+'" data-white-price="'+whitePrice+'">'+
    '<a class="pimg" href="'+p.href+'">'+(p.badge?'<span class="badge">'+p.badge+'</span>':'')+
      '<img src="'+p.white+'" alt="'+p.name+'" loading="lazy"></a>'+
    '<div class="pbody">'+
      '<div class="ptop"><h3>'+p.name+'</h3>'+
        '<div class="swatches"><span class="swatch b" data-c="black"></span><span class="swatch w sel" data-c="white"></span></div></div>'+
      '<p class="ptag">'+p.tag+'</p>'+
      '<div class="pprice">'+whitePrice+'</div>'+
      '<a href="'+p.href+'" class="btn btn-primary btn-sm btn-block" style="margin-top:4px">Shop</a>'+
    '</div></div>';
}
/* accessory/service card — single image, no finish swatches */
function acardHTML(p){
  return '<div class="pcard">'+
    '<a class="pimg" href="'+p.href+'">'+(p.badge?'<span class="badge">'+p.badge+'</span>':'')+
      '<img src="'+p.img+'" alt="'+p.name+'" loading="lazy"></a>'+
    '<div class="pbody">'+
      '<div class="ptop"><h3>'+p.name+'</h3></div>'+
      '<p class="ptag">'+p.tag+'</p>'+
      '<div class="pprice">'+p.price+'</div>'+
      '<a href="'+p.href+'" class="btn btn-primary btn-sm btn-block" style="margin-top:4px">Shop</a>'+
    '</div></div>';
}
function megaHTML(p){
  var img = (p.id==='lumone') ? p.black : p.white;   /* lumone-white has a bg box; use the clean cutout */
  return '<a class="mega-card" href="'+p.href+'"><div class="ph"><img src="'+img+'" alt="'+p.name+'"></div>'+
    '<span class="nm">'+p.name+'</span></a>';
}

function bindSwatches(scope){
  (scope||document).querySelectorAll('.pcard').forEach(function(card){
    if(card._bound) return; card._bound=true;
    var img=card.querySelector('.pimg img');
    var priceEl=card.querySelector('.pprice');
    card.querySelectorAll('.swatch').forEach(function(s){
      s.onclick=function(e){ e.preventDefault();
        card.querySelectorAll('.swatch').forEach(function(x){x.classList.remove('sel');}); s.classList.add('sel');
        var isWhite=s.dataset.c==='white';
        var src=isWhite?card.dataset.white:card.dataset.black;
        img.style.opacity='0'; setTimeout(function(){img.src=src;img.style.opacity='1';},150);
        if(priceEl) priceEl.textContent=isWhite?card.dataset.whitePrice:card.dataset.blackPrice;
      };
    });
  });
}

/* tweakable arrow style — values written by the Tweaks panel on mobile-preview.html */
window.applyArrowTweaks=function(t){ var de=document.documentElement;
  if(t.alpha!=null) de.style.setProperty('--arrow-alpha',t.alpha);
  if(t.blur!=null) de.style.setProperty('--arrow-blur',t.blur+'px');
  if(t.style) de.setAttribute('data-arrow-style',t.style); };
try{ var _at=JSON.parse(localStorage.getItem('karbanArrowTweaks')||'null'); if(_at) window.applyArrowTweaks(_at); }catch(e){}

/* ---- review card "Read more" toggle — shared by the home page (.rev-grid) and
   the PDP (#pp-reviews). Deliberately quote-agnostic: the home page wraps review
   text in literal quote marks, the PDP doesn't — that's handled by the
   .rt-quoted CSS class (::before/::after), not baked into this text swap, so
   the same toggle works for both without mismatched punctuation appearing only
   after a click. ---- */
window.toggleReviewText=function(btn){
  var p=btn.parentNode;
  var expanded=p.classList.toggle('rt-expanded');
  var text=expanded ? p.getAttribute('data-full') : p.getAttribute('data-short');
  p.childNodes[0].nodeValue=text+' ';
  btn.textContent=expanded ? 'Read less' : 'Read more';
};

/* ---- generic mobile sliders: card sections slide one at a time, with arrows + position dots ---- */
function initMobileSliders(){
  var sels='.range-grid,.vid-grid,.rev-grid,.exp-grid,.exp-swipe,.box-grid,.fswipe';
  document.querySelectorAll(sels).forEach(function(el){
    if(el._msl||el.children.length<2) return;
    /* skip sections that already ship their own nav arrows (e.g. .fswipe in .fswipe-wrap with .cnav)
       — otherwise we'd stack a 2nd translucent circle on top and it reads as a ghost button */
    if(el.parentNode && el.parentNode.querySelector(':scope > .cnav')){ el._msl=true; return; }
    el._msl=true;
    el.classList.add('mslide');
    var wrap=document.createElement('div'); wrap.className='mslider';
    el.parentNode.insertBefore(wrap,el); wrap.appendChild(el);
    var prev=document.createElement('button'); prev.type='button'; prev.className='msl-btn msl-prev'; prev.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg>'; prev.setAttribute('aria-label','Previous');
    var next=document.createElement('button'); next.type='button'; next.className='msl-btn msl-next'; next.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>'; next.setAttribute('aria-label','Next');
    var dots=document.createElement('div'); dots.className='msl-dots';
    /* step by visual COLUMN, not by DOM child — a 2-row grid (e.g. .rev-scroll) stacks
       2 cards per column sharing the same offsetLeft, so stepping per-child got "next"
       stuck landing on the 2nd card of the same column (offsetLeft unchanged, no scroll
       happened). Group children by offsetLeft first; single-row sliders end up with one
       child per group same as before, so this is a no-op for them. */
    function groups(){ var k=el.children, out=[];
      for(var i=0;i<k.length;i++){ var l=k[i].offsetLeft;
        if(!out.length || Math.abs(l-out[out.length-1].left)>1) out.push({left:l}); }
      return out; }
    var g0=groups();
    for(var i=0;i<g0.length;i++){ var d=document.createElement('span'); d.className='msl-dot'; dots.appendChild(d); }
    wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(dots);
    function idx(){ var g=groups(),s=el.scrollLeft,best=0,bd=1e9;
      for(var i=0;i<g.length;i++){ var d=Math.abs(g[i].left-el.offsetLeft-s); if(d<bd){bd=d;best=i;} } return best; }
    function upd(){ var g=groups(), i=idx(), n=g.length;
      var atEnd=el.scrollLeft>=el.scrollWidth-el.clientWidth-8;
      /* nothing to scroll to (e.g. a product with only a couple of reviews) — hide
         the nav entirely instead of leaving disabled arrows/dots sitting there */
      wrap.classList.toggle('no-scroll', el.scrollWidth<=el.clientWidth+4);
      prev.disabled=i<=0; next.disabled=i>=n-1||atEnd;
      [].forEach.call(dots.children,function(d,j){ d.classList.toggle('on',j===i); }); }
    function go(dir){ var g=groups(); var n=g.length; var t=Math.min(n-1,Math.max(0,idx()+dir));
      var to=g[t].left-el.offsetLeft, from=el.scrollLeft, t0=null;
      /* mandatory scroll-snap re-snaps every programmatic scrollLeft write — disable it while animating */
      el.style.scrollSnapType='none';
      function tick(ts){ if(t0===null)t0=ts; var p=Math.min(1,(ts-t0)/280), e=1-Math.pow(1-p,3);
        el.scrollLeft=from+(to-from)*e;
        if(p<1){ requestAnimationFrame(tick); } else { el.style.scrollSnapType=''; upd(); } }
      requestAnimationFrame(tick); }
    prev.onclick=function(){go(-1);}; next.onclick=function(){go(1);};
    el.addEventListener('scroll',function(){ if(el._mslT)cancelAnimationFrame(el._mslT); el._mslT=requestAnimationFrame(upd); },{passive:true});
    /* breakpoints change the row/column count (e.g. .rev-scroll's 2-col -> 3-col at
       1020px), which can flip whether the content overflows at all */
    window.addEventListener('resize',function(){ if(el._mslR)cancelAnimationFrame(el._mslR); el._mslR=requestAnimationFrame(upd); },{passive:true});
    upd();
  });
}

/* ---- press strip: auto-sliding ticker on phones; manual swipe pauses it; tap opens the article popup ---- */
function initPressTicker(){
  if(!window.matchMedia('(max-width:760px)').matches) return;
  var row=document.getElementById('press-row'); if(!row||row._tick||!row.children.length) return; row._tick=true;
  row.classList.add('ticker');
  row.innerHTML+=row.innerHTML; /* duplicate items for a seamless loop */
  var paused=false, resumeT=null, pos=null;
  function hold(){ paused=true; pos=null; if(resumeT)clearTimeout(resumeT); }
  function release(){ if(resumeT)clearTimeout(resumeT); resumeT=setTimeout(function(){ paused=false; },4000); }
  row.addEventListener('touchstart',hold,{passive:true});
  row.addEventListener('pointerdown',hold,{passive:true});
  row.addEventListener('touchend',release,{passive:true});
  row.addEventListener('pointerup',release,{passive:true});
  function loop(){
    if(!paused){ var half=row.scrollWidth/2;
      if(pos===null) pos=row.scrollLeft;
      pos+=0.6; if(half>0&&pos>=half) pos-=half;
      row.scrollLeft=pos; }
    requestAnimationFrame(loop); }
  requestAnimationFrame(loop);
}

document.addEventListener('DOMContentLoaded', function(){
  var rg=document.getElementById('range-grid'); if(rg){ rg.innerHTML=PRODUCTS.map(pcardHTML).join(''); bindSwatches(rg); }
  var pr=document.getElementById('press-row'); if(pr) pr.innerHTML=PRESS.map(function(p,i){
    return '<button class="press-item" onclick="openPress('+i+')" aria-label="'+p.name+'"><img class="press-logo" src="'+p.logo+'" alt="'+p.name+'"><span class="press-note">'+p.note+'</span></button>'; }).join('');
  var rv=document.getElementById('rev-grid');
  if(rv){
    // Live path: window.HOME_REVIEWS (set by kbv4-home.liquid from the selected
    // product(s)' custom.pdp_reviews metafield — {name, location, text, rating, img}).
    // Falls back to the static list only if no product is configured yet / has no reviews.
    var liveReviews=(window.HOME_REVIEWS && window.HOME_REVIEWS.length) ? window.HOME_REVIEWS : FALLBACK_REVIEWS;
    var normReviews=liveReviews.map(function(r){
      return { n:r.name||r.n||'', s:r.location||r.s||'', img:r.img||'', video:r.video||'', t:r.text||r.t||'', rating:r.rating||5 };
    });
    var REV_LIMIT=160;
    function escAttr(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
    rv.innerHTML=normReviews.map(function(r){
      var stars=''; for(var i=0;i<r.rating;i++){ stars+='★'; }
      var isLong=r.t.length>REV_LIMIT;
      var short=isLong ? r.t.slice(0,REV_LIMIT).replace(/\s+\S*$/,'')+'…' : r.t;
      var media = r.video
        ? '<div class="rvideo"><video poster="'+r.img+'" controls playsinline preload="metadata"><source src="'+r.video+'" type="video/mp4"></video></div>'
        : (r.img?'<div class="rimg" onclick="openImgZoom(\''+r.img+'\')"><img src="'+r.img+'" alt="Karban in '+r.n+'’s home" loading="lazy"><span class="zicon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-3.4-3.4M11 8v6M8 11h6"/></svg></span></div>':'');
      return '<div class="rcard">'+
        media+
        '<span class="stars">'+stars+'</span>'+
        '<p class="rt rt-quoted" data-full="'+escAttr(r.t)+'" data-short="'+escAttr(short)+'">'+short+
          (isLong?' <button type="button" class="rt-more" onclick="toggleReviewText(this)">Read more</button>':'')+
        '</p>'+
        '<div class="rf"><span class="ravatar">'+r.n.charAt(0)+'</span><div><div class="rn">'+r.n+'</div>'+
        '<div class="rm">Airzone · '+r.s+' · Verified</div></div></div></div>'; }).join('');
  }
  var vg=document.getElementById('vid-grid'); if(vg) vg.innerHTML=VIDEOS.map(function(v,i){
    return '<a class="vid" href="javascript:void(0)" onclick="openVid('+i+')">'+
      '<img src="https://img.youtube.com/vi/'+v.id+'/maxresdefault.jpg" onerror="this.onerror=null;this.src=\'https://img.youtube.com/vi/'+v.id+'/hqdefault.jpg\'" alt="'+v.t+'" loading="lazy">'+
      '<span class="ov"></span><span class="play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>'+
      '<span class="vt">'+v.t+'</span></a>'; }).join('');

  initReveal();
  setTimeout(initMobileSliders,60); /* after pdp.js has rendered its sections */
  window.addEventListener('load',initMobileSliders);
  initPressTicker();
  if(location.hash==='#watch') setTimeout(openDZ,250);
  if(location.hash==='#press') setTimeout(function(){ openPress(0); },250);
  if(location.hash==='#air') setTimeout(function(){ var b=document.querySelector('.nav-links [data-cat="Air Purifiers"]'); if(b) toggleCat(b); },250);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){ closeCat(); closePress(); closeVid(); closeDZ(); closeImgZoom(); }
    if(document.getElementById('vmodal') && document.getElementById('vmodal').classList.contains('open')){
      if(e.key==='ArrowRight') vidStep(1); if(e.key==='ArrowLeft') vidStep(-1);
    }
  });
});

/* video popup */
var vidIdx=0;
function openVid(i){ vidIdx=i; vmShow(); document.getElementById('vmodal').classList.add('open'); document.body.style.overflow='hidden'; }
function vmShow(){ var v=VIDEOS[vidIdx]; if(!v) return;
  document.getElementById('vm-iframe').src='https://www.youtube.com/embed/'+v.id+'?autoplay=1&rel=0&playsinline=1&modestbranding=1&origin='+encodeURIComponent(location.origin);
  document.getElementById('vm-title').textContent=v.t;
  document.getElementById('vm-count').textContent=(vidIdx+1)+' / '+VIDEOS.length; }
function vidStep(d){ vidIdx=(vidIdx+d+VIDEOS.length)%VIDEOS.length; vmShow(); }
function closeVid(){ var m=document.getElementById('vmodal'); if(!m) return; document.getElementById('vm-iframe').src=''; m.classList.remove('open'); document.body.style.overflow=''; }

/* category mega dropdown */
function toggleCat(btn){
  var m=document.getElementById('mega'),s=document.getElementById('megash');
  var cat=btn.dataset.cat, already=btn.classList.contains('on');
  document.querySelectorAll('.nav-links button').forEach(function(b){b.classList.remove('on');});
  if(already){ closeCat(); return; }
  btn.classList.add('on');
  document.getElementById('mega-grid').innerHTML=PRODUCTS.filter(function(p){return p.cat===cat;}).map(megaHTML).join('');
  m.classList.add('open'); s.classList.add('open');
}
function closeCat(){ var m=document.getElementById('mega'),s=document.getElementById('megash');
  if(m){m.classList.remove('open');s.classList.remove('open');document.querySelectorAll('.nav-links button').forEach(function(b){b.classList.remove('on');});} }
function toggleMenu(){
  var m=document.getElementById('mmenu'), opening=!m.classList.contains('open');
  m.classList.toggle('open');
  if(!opening) closeMobileCats();   /* collapse all categories so the drawer re-opens fresh */
}

/* mobile drawer category accordion — mirrors desktop toggleCat: only one
   category's products shown at a time, instead of every product flattened
   into one long always-open list */
function closeMobileCats(){
  document.querySelectorAll('#mmenu .mm-cat').forEach(function(b){ b.classList.remove('on'); });
  document.querySelectorAll('#mmenu .mm-group').forEach(function(g){ g.style.maxHeight=null; });
}
function toggleMobileCat(btn){
  var group=btn.nextElementSibling, already=btn.classList.contains('on');
  closeMobileCats();
  if(already) return;
  btn.classList.add('on');
  if(group) group.style.maxHeight=group.scrollHeight+'px';
}

/* press popup — summary only, no outbound CTA (founder call 2026-07-16: keep visitors
   on-site). PRESS[].url is intentionally retained in the data for future use. */
function openPress(i){ var p=PRESS[i]; if(!p) return;
  var lg=document.getElementById('pm-logo'); lg.src=p.logo; lg.alt=p.name;
  document.getElementById('pm-head').textContent=p.line;
  document.getElementById('pm-sum').textContent=p.summary;
  var cta=document.getElementById('pm-cta'); if(cta) cta.remove();
  document.getElementById('pmodal').classList.add('open'); document.body.style.overflow='hidden';
}
function closePress(){ var m=document.getElementById('pmodal'); if(m){m.classList.remove('open');document.body.style.overflow='';} }

/* review-image zoom (shared lightbox) */
function openImgZoom(src){ var m=document.getElementById('imgzoom'); if(!m) return; document.getElementById('imgzoomImg').src=src; m.classList.add('open'); document.body.style.overflow='hidden'; }
function closeImgZoom(){ var m=document.getElementById('imgzoom'); if(!m) return; m.classList.remove('open'); document.body.style.overflow=''; }

/* 3-reel video modal — all reels autoplay TOGETHER (muted) and loop individually;
   tapping a reel's controls plays it with sound */
var _dzBound=false;
function dzVids(){ var m=document.getElementById('dzmodal'); return m?Array.prototype.slice.call(m.querySelectorAll('.dz-reel video')):[]; }
function dzMobile(){ return window.matchMedia('(max-width:760px)').matches; }
/* position each tag inside the letterboxed video content box (mobile) */
function dzLayoutTags(){
  dzVids().forEach(function(v){ var reel=v.closest('.dz-reel'); var tag=reel.querySelector('.dz-tag'); if(!tag) return;
    if(!dzMobile()||!v.videoWidth){ tag.style.left='';tag.style.top='';tag.style.right='';tag.style.bottom=''; return; }
    var cw=reel.clientWidth, ch=reel.clientHeight, s=Math.min(cw/v.videoWidth, ch/v.videoHeight);
    var x=(cw-v.videoWidth*s)/2, y=(ch-v.videoHeight*s)/2;
    tag.style.left=(x+14)+'px'; tag.style.top=(y+14)+'px'; tag.style.right='auto'; tag.style.bottom='auto';
  }); }
/* mobile: only the reel in view plays; arrows track position */
function dzIdx(){ var m=document.getElementById('dzmodal'); var reels=m&&m.querySelector('.dz-reels'); return reels?Math.round(reels.scrollLeft/Math.max(1,reels.clientWidth)):0; }
function dzArrows(){ var idx=dzIdx(), n=dzVids().length;
  var p=document.getElementById('dzPrev'), nx=document.getElementById('dzNext');
  if(p) p.disabled=idx<=0; if(nx) nx.disabled=idx>=n-1; }
function dzStep(d){ var m=document.getElementById('dzmodal'); var reels=m&&m.querySelector('.dz-reels'); if(!reels) return;
  var n=dzVids().length; var idx=Math.min(n-1,Math.max(0,dzIdx()+d));
  var from=reels.scrollLeft, to=idx*reels.clientWidth, t0=null;
  /* mandatory scroll-snap re-snaps every programmatic scrollLeft write — disable it while animating */
  reels.style.scrollSnapType='none';
  function tick(ts){ if(t0===null) t0=ts; var p=Math.min(1,(ts-t0)/280); var e=1-Math.pow(1-p,3);
    reels.scrollLeft=from+(to-from)*e; if(p<1){ requestAnimationFrame(tick); } else { reels.style.scrollSnapType=''; dzSync(); } }
  requestAnimationFrame(tick); }
function dzSync(){ var m=document.getElementById('dzmodal'); if(!m) return; var reels=m.querySelector('.dz-reels'); if(!reels) return;
  dzArrows();
  if(!dzMobile()) return;
  var idx=dzIdx();
  dzVids().forEach(function(v,i){ if(i===idx){ if(v.paused){ try{ v.play(); }catch(e){} } } else { try{ v.pause(); }catch(e){} } }); }
function dzPlay(){ var mob=dzMobile();
  dzVids().forEach(function(v,i){
    v.closest('.dz-reel').classList.add('live');
    try{ v.currentTime=0; v.muted=true; v.loop=true; if(!mob||i===0){ v.play(); } else { v.pause(); } }catch(e){} }); }
function openDZ(){ var m=document.getElementById('dzmodal'); if(!m) return; m.classList.add('open'); document.body.style.overflow='hidden';
  var reels=m.querySelector('.dz-reels');
  if(reels){ reels.scrollLeft=0;
    if(!reels._swipeBound){ reels._swipeBound=true;
      reels.addEventListener('scroll',function(){
        dzArrows();
        if(reels._syncT) clearTimeout(reels._syncT);
        reels._syncT=setTimeout(dzSync,120);
      },{passive:true}); } }
  dzArrows();
  if(!_dzBound){ _dzBound=true; dzVids().forEach(function(v){
    v.loop=true;
    v.addEventListener('loadedmetadata',dzLayoutTags);
    v.addEventListener('play', function(){ /* unmuted user-started reel: mute the others so sounds don't overlap */
      if(!v.muted){ dzVids().forEach(function(o){ if(o!==v){ o.muted=true; } }); } });
  });
  window.addEventListener('resize',dzLayoutTags); }
  dzPlay(); dzLayoutTags(); }
function closeDZ(){ var m=document.getElementById('dzmodal'); if(!m) return;
  m.querySelectorAll('video').forEach(function(v){ try{ v.pause(); }catch(e){} }); m.classList.remove('open'); document.body.style.overflow=''; }

function initReveal(){
  var els=[].slice.call(document.querySelectorAll('.reveal'));
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
  var io=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);} }); },{threshold:.1});
  els.forEach(function(e){ io.observe(e); });
  setTimeout(function(){ els.forEach(function(e){e.classList.add('in');}); },1400);
}

/* footer column accordion (mobile only, CSS gates the collapse above 560px) —
   tap a column heading to expand its links; opening one closes the others,
   same single-open pattern as the mobile nav's toggleMobileCat(). */
function initFootCols(){
  var cols=document.querySelectorAll('.foot-cols .foot-col');
  cols.forEach(function(col){
    var head=col.querySelector('.foot-col-head');
    var btn=col.querySelector('.foot-col-toggle');
    var body=col.querySelector('.foot-col-body');
    if(!head || !btn || !body) return;
    /* whole heading row is the tap target (CSS already gives it cursor:pointer) —
       not just the small + icon; the icon still needs its own aria-hidden since
       the row itself now carries the click + aria-expanded state */
    btn.setAttribute('aria-hidden','true');
    btn.setAttribute('tabindex','-1');
    head.setAttribute('role','button');
    head.setAttribute('tabindex','0');
    head.setAttribute('aria-expanded','false');
    function openThis(){
      var already=col.classList.contains('open');
      cols.forEach(function(c){
        c.classList.remove('open');
        var h=c.querySelector('.foot-col-head'); if(h) h.setAttribute('aria-expanded','false');
        var bd=c.querySelector('.foot-col-body'); if(bd) bd.style.maxHeight=null;
      });
      if(!already){
        col.classList.add('open');
        head.setAttribute('aria-expanded','true');
        body.style.maxHeight=body.scrollHeight+'px';
      }
    }
    head.addEventListener('click', openThis);
    head.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); openThis(); }
    });
  });
}

/* ---- mobile nav (2026-07-14): full drawer mirroring desktop + working cart icon ---- */
document.addEventListener('DOMContentLoaded', function(){
  initFootCols();
  /* build the mobile drawer from the same PRODUCTS data as the desktop dropdowns */
  var mm=document.getElementById('mmenu');
  if(mm && window.PRODUCTS){
    var cats=['Air Purifiers','Bladeless Fans','Lights'], html='';
    cats.forEach(function(c){
      html+='<button type="button" class="mm-cat" onclick="toggleMobileCat(this)">'+c+
        '<svg class="mm-chev" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button>';
      html+='<div class="mm-group">';
      PRODUCTS.filter(function(p){return p.cat===c;}).forEach(function(p){
        html+='<a class="mm-prod" href="'+p.href+'">'+p.name+'</a>';
      });
      html+='</div>';
    });
    html+='<a href="/collections/all">Store</a>'+
          '<a href="/pages/compare">Compare all products</a>'+
          '<a href="/pages/support-1">Support</a>';
    mm.innerHTML=html;
  }
  /* cart icon → cart page (works across the static preview); account → account page */
/*var bag=document.querySelector('.nav-ic[aria-label="Bag"]');
  if(bag){ bag.style.cursor='pointer'; bag.addEventListener('click',function(){ window.location.href='https://karban.in/cart'; }); }*/
  /* account icon: relying on KwikPass auto-intercepting the plain href="/account"
     click raced its own script load — clicking before kp-merchant-v2.js finished
     loading fell straight through to Shopify's native /account login instead of
     KwikPass's popup.
     FIRST FIX (reverted): called window.kpHandleLogin('/account') directly —
     wrong call convention, it hard-redirected to /kp-account instead of opening
     the popup. Don't know KwikPass's real API well enough to call it directly.
     CURRENT FIX: don't call into KwikPass's API at all. Just hold an early click
     (preventDefault), wait for kpHandleLogin to become defined as a signal that
     KwikPass has finished initialising (same init pass that attaches its own
     click listener to this element), then re-dispatch a REAL click via acc.click()
     — KwikPass's own already-attached listener handles that exactly like it always
     did (same popup as before), we're just delaying the click, not reimplementing
     KwikPass's behaviour ourselves. accReplaying guards against this handler
     re-intercepting its own re-dispatched click. Poll capped at 60s; if KwikPass
     never loads, the click is simply never replayed — deliberately never falls
     back to native /account, so Shopify's login can't show from here at all.
     NOTE: this replaces an EARLIER disabled listener that unconditionally forced
     window.location.href on every click, permanently bypassing KwikPass even
     after it loaded — this version never fights KwikPass, it only ever waits
     for it and then lets it handle the click natively. */
  var acc=document.querySelector('.nav-ic[aria-label="Account"]');
  if(acc){
    var accReplaying=false;
    acc.addEventListener('click',function(e){
      if(accReplaying) return;                       /* our own re-dispatched click — let KwikPass's listener handle it */
      if(typeof window.kpHandleLogin==='function') return; /* KwikPass already loaded — its own listener already handles this click natively */
      e.preventDefault();
      var tries=0;
      var wait=setInterval(function(){
        tries++;
        if(typeof window.kpHandleLogin==='function'){
          clearInterval(wait);
          accReplaying=true; acc.click(); accReplaying=false;
        } else if(tries>=600){ clearInterval(wait); } /* ~60s — give up quietly, never navigate to native login */
      },100);
    });
  }
});
  